// import axios from 'axios'
import storage from 'didi-store'
import { EventBus } from '@didi/events'
import { urlParse } from '@/common/utils/util'
import hostsConfig from '@/common/config/hosts'
import { omitBy, isNaN, isUndefined, isNull, isEmpty } from 'lodash-es'
import { getBDLocale, getBDCountry, i18n, getBDTimezone } from '@/common/utils/i18n'
import { errnoData, preloading } from './middlewares'
import { trackEvent } from '@/common/utils/log'
import qs from 'qs'
import { requestTrackStart, requestTrackEnd } from '../../raven'
import { getBizId } from './BizUtils'
import { isAbasteceBiz } from '@/common/utils/BizUtils'
import VueI8n from '@/i18n/locale'
import dajax from '@didi/dajax'
const env = process.env.NODE_ENV
const hosts = hostsConfig.hosts

export const getCommonParams = function () {
  return {
    from_app: 1,
    ticket: urlParse(location.href).ticket || storage.get('ticket'),
    // ticket: '027f29fec60d00f4c11b2f642f98e03a0002200386000',
    locale: getBDLocale(),
    country: getBDCountry(),
    timezone: getBDTimezone(),
  }
}

/**
 * 识别gateway地址，自动转换请求配置
 * 将url替换成/gateway
 * 将api添加到params中
 */
export function transferConfig(url) {
  if (url.indexOf('http') !== -1 || url.indexOf('//:') !== -1) {
    return {
      transUrl: url,
      transParams: {},
    }
  }
  let transParams = {}
  let transUrl = url
  const isGatewayReg = url.indexOf('.') !== -1
  const isCommonGatewayReg = /^common./g
  if (isGatewayReg) {
    if (isCommonGatewayReg.test(url)) {
      transUrl = '/common'
      transParams = {
        api: url,
      }
    } else {
      transUrl = '/gateway'
      transParams = {
        api: url,
      }
    }
  }
  return {
    transUrl,
    transParams,
  }
}

export function prefixUrl(
  url,
  params,
  options = { isFilterEmptyParams: false, isAddCommonParams: false },
) {
  let tmpParams = { ...params }
  if (options.isFilterEmptyParams) {
    // 过滤错误函数
    tmpParams = omitBy(tmpParams, v => isNaN(v) || isUndefined(v) || isNull(v) || v === '')
  }
  if (options.isAddCommonParams) {
    const commonParams = getCommonParams()
    tmpParams = {
      ...commonParams,
      ...tmpParams,
    }
  }
  if (url.indexOf('http') < 0) {
    if (url.indexOf('/') === 0) {
      url = hosts.api + url
    } else {
      // 如果是xxx.xxx.xxx兼容
      const { transUrl, transParams } = transferConfig(url)
      tmpParams = { ...transParams, ...tmpParams }
      url = hosts.gateway + transUrl + '?' + qs.stringify(tmpParams)
      return url
    }
  }
  // 参数处理逻辑
  if (url.indexOf('?') !== -1) {
    return url
  } else if (!isEmpty(tmpParams)) {
    return url + '?' + qs.stringify(tmpParams)
  }
  return url
}
let isUnLogin = false
function setRequest(method, config, options = {}) {
  const urlPath = window.location.href || ''
  const {
    transParams: { api },
  } = transferConfig(typeof config === 'string' ? config : config.url)
  // config 可能是url，也可能是放到config.url里面
  if (typeof config === 'string') {
    config = Object.assign(
      {
        method,
        url: prefixUrl(config),
      },
      arguments[2],
    )
  } else {
    config.url = prefixUrl(config.url)
  }
  if (env === 'development') {
    // 主要为了proxy代理
    config.headers = {
      ...config.headers,
    }
    if (api) config.headers.api = api
  }
  config.reqId = requestTrackStart({
    url: config.url,
    params: config.params,
  })
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    config.method = method
    config.needEncrypt = true
    if (api) config.api = api

    const globalParams = await SodaGlobalParams()
    const commonParams = getCommonParams()
    config.params = Object.assign(
      commonParams,
      {
        ...globalParams,
        ticket: globalParams.ticket || commonParams.ticket,
        bizId: getBizId(),
      },
      config.params || {},
    )
    const { showToast = true } = options || {}
    const errToastText = isAbasteceBiz()
      ? VueI8n.t('Internal_Tools_App_qYbb_MgvG' /** 系统异常，请稍后重试 */)
      : i18n.gettext('您当前的网络环境不太好')
    dajax(config)
      .then(response => {
        if (response.status !== 200) {
          reject(response)
        }
        return response
      })
      .then(({ data }) => {
        requestTrackEnd({
          reqId: config.reqId,
          traceId: data.traceId || data.trace,
        })
        trackEvent('sailing_gattarman_x_api_traceID', {
          traceID: data.traceId,
          baseUrl: config.url,
          ...config,
          urlPath,
        })
        if (!data || data.errno) {
          if (showToast) EventBus.emit('ajaxErrorToast', data.errmsg || errToastText)
          if (data.data && data.data.redirectUrl) {
            // logout
            if (window.SODA_RN) {
              if (!isUnLogin) {
                window.SodaBD.requestLogout({}, () => {})
              }
              isUnLogin = true
            } else {
              if (!isUnLogin) {
                trackEvent('sailing_gattarman_x_page_entry', {
                  pageName: 'login',
                })
                if (config && config.params && config.params.current) {
                  trackEvent('sailing_gattarman_x_unlogin_to_login_time_sw', {
                    phase: 2,
                    time_diff: +new Date() - config.params.current,
                  })
                }
              }
              isUnLogin = true

              if (config.url.includes('getUserInfo')) {
                storage.set('notLoginToRedirect', +new Date())
              }

              window.setTimeout(() => {
                location.href = data.data.redirectUrl
              }, 10)
            }
          }
          trackEvent('sailing_gattarman_x_api_message_error', {
            errorType: data && data.errno,
            errorMessage: data && data.errmsg,
          })
          reject(data)
        } else {
          isUnLogin = false
        }
        resolve(data)
      })
      .catch(error => {
        if (showToast) EventBus.emit('ajaxErrorToast', error.errmsg || errToastText + error)
        reject(error)
      })
  })
}

export const request = ['get', 'post'].reduce((api, method) => {
  api[method] = setRequest.bind(null, method)
  return api
}, {})

/**
 * 通用中间件处理方法, 支持多种中间件定义方式
 * @param {Iterator} middlewares 迭代器
 */
export const createHelper =
  (middlewares = []) =>
  (method, ...params) => {
    const ret = method.apply(null, params)
    return new Promise((resolve, reject) => {
      const iterator = middlewares[Symbol.iterator]()
      const next = result => {
        const el = iterator.next()

        if (el.done) {
          result.then(resolve, reject)
          return
        }
        result = el.value(result)
        next(result)
      }
      next(ret)
    })
  }

export function SodaGlobalParams() {
  return new Promise((resolve, reject) => {
    if (window && window.Soda && window.Soda.getGlobalParams) {
      try {
        Soda.getGlobalParams((result = {}) => {
          const { errNo = 0, data = {} } = result
          for (const key in data) {
            if (!data[key]) {
              delete data[key]
            }
          }
          if (errNo === 0) {
            resolve(data)
          } else {
            resolve({})
          }
        })
      } catch (e) {
        resolve({})
      }
    } else {
      resolve({})
    }
  })
}

export const requestHelper = createHelper([errnoData, preloading])
export const requestSilence = createHelper([errnoData])
